import { render, staticRenderFns } from "./AddressLink.vue?vue&type=template&id=ebf8cf6a&"
import script from "./AddressLink.vue?vue&type=script&lang=js&"
export * from "./AddressLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports